import { useContext } from 'react';

import { OmeMeetTeamEntryStateContext } from './OmeMeetTeamEntryContextProvider';
import { OmeMeetTeamEntryFiltersStateContext } from './OmeMeetTeamEntryFiltersContextProvider';

import OmeMeetTeamEntryData from './OmeMeetTeamEntryData';

import Constants from '@usas/ui-web/utils/Constants';

const useOmeMeetTeamEntryData = () => {
  const [omeMeetTeamEntryState, setOmeMeetTeamEntryState] = useContext(OmeMeetTeamEntryStateContext);
  const [omeMeetTeamEntryFiltersState, setOmeMeetTeamEntryFiltersState] = useContext(OmeMeetTeamEntryFiltersStateContext);

  const searchMeetTeamEntry = (filterObject, sortBy) => {
    setOmeMeetTeamEntryFiltersState({ ...omeMeetTeamEntryFiltersState, filterObject, sortBy });
    OmeMeetTeamEntryData.searchMeetTeamEntryData(JSON.stringify(filterObject), sortBy, omeMeetTeamEntryState, setOmeMeetTeamEntryState);
  };

  const getOmeMeetTeamEntry = (omeMeetId, filterObject) => {
    OmeMeetTeamEntryData.getOmeMeetTeamEntryData(omeMeetId, JSON.stringify(filterObject), omeMeetTeamEntryState, setOmeMeetTeamEntryState);
  };

  const clearOmeMeetTeamEntryArrayData = () => {
    setOmeMeetTeamEntryState({
      ...omeMeetTeamEntryState,
      isArrayLoading: false,
      isArrayLoaded: false,
      isSaving: false,
      isSaved: false,
      arrayData: [],
      message: '',
      omeMeetId: Constants.DEFAULT_ID
    });
  };

  const clearOmeMeetTeamEntryObjData = () => {
    setOmeMeetTeamEntryState({
      ...omeMeetTeamEntryState,
      isObjLoading: false,
      isObjLoaded: false,
      isSaving: false,
      isSaved: false,
      objData: {},
      message: '',
      omeMeetId: Constants.DEFAULT_ID
    });
  };

  const resetOmeMeetTeamEntryState = () => {
    setOmeMeetTeamEntryState({
      ...omeMeetTeamEntryState,
      isArrayLoading: false,
      isArrayLoaded: false,
      arrayData: [],
      isObjLoading: false,
      isObjLoaded: false,
      isSaving: false,
      isSaved: false,
      objData: {},
      message: '',
      omeMeetId: Constants.DEFAULT_ID
    });
  };

  const resetOmeMeetTeamEntryFiltersState = () => {
    setOmeMeetTeamEntryFiltersState({
      filterObject: {},
      sortBy: ''
    });
  };

  return {
    omeMeetTeamEntryState,
    setOmeMeetTeamEntryState,
    omeMeetTeamEntryFiltersState,
    setOmeMeetTeamEntryFiltersState,
    searchMeetTeamEntry,
    getOmeMeetTeamEntry,
    clearOmeMeetTeamEntryArrayData,
    clearOmeMeetTeamEntryObjData,
    resetOmeMeetTeamEntryState,
    resetOmeMeetTeamEntryFiltersState
  };
};

export default useOmeMeetTeamEntryData;